// @ts-ignore
import { KeepAlive } from 'umi'
import React, { FC } from 'react'
import { Tabs as AntdTabs, TabPaneProps as AntdTabPaneProps } from 'antd'

const { TabPane: AntdTabPane } = AntdTabs

export interface TabPaneProps extends AntdTabPaneProps {
    keepAlive?: boolean
}

export const TabPane: FC<TabPaneProps> = props => {
    const { keepAlive, children, ...restProps } = props
    return <AntdTabPane {...restProps}>{keepAlive ? <KeepAlive>{children}</KeepAlive> : children}</AntdTabPane>
}
